export default {
    PARTICIPANTS_NUM: "capacity",
    PARTICIPANTS_AGES: "participants-ages",
    PARTICIPANTS_AGES_NO_ENCODING: "participants-ages-no-encoding",
}